export const buildCloudinaryImageUrl = ({
    publicId,
    url,
    width = 400,
    quality = "auto",
    type = "image",
}) => {
    const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

    let transformation = `f_auto,q_${quality},w_${width},c_limit`;

    if (publicId) {
        return `https://res.cloudinary.com/${cloudName}/${type}/upload/${transformation}/${publicId}`;
    }

    if (url && url.includes("/upload/")) {
        if (url.includes(".svg")) return url; // Skip transformation for SVG images

        if(url.includes(".gif")){
            transformation = `f_auto,q_auto:eco,w_${200},c_scale,fl_lossy`;
             return url.replace("/upload/", `/upload/${transformation}/`);
        }
        if (url.includes("f_auto") || url.includes("q_auto")) return url;

        return url.replace("/upload/", `/upload/${transformation}/`);
    }

    return url || "";
};